import { DatePicker } from './date-picker.constants';

export const Tooltips = {
    FILTER_TABS: 'Filter through your subscription to find the data you need by making selections on the below filters. Countries and Categories filters are mandatory.',
    RESET_FILTERS: 'Clear all current filter selections.',
    LOWEST_LEVEL_CATEGORIES: 'Select all categories below this level.',
    DATE_RANGE: 'The range of individual days that can be selected, with a new day added every 24 hours. The beginning of the date range is called "Start Date" and the end of the date range is called "End Date".',
    FREQUENCY: getDailyFrequencyTooltipText(),
    DATA_TYPE: 'The various data points that can be selected and included in the export file, like SKU price, availability or rating.',
    PRICE_POINT: 'Price per SKU is sold as price. Price per Unit is price per volume (e.g. ml), weight (e.g. grams) or count.',
    CURRENCY: 'The different monetary units used by each country tracked in Via that can be selected.',
    FILE_TYPE: 'Select the format you want your exported data file saved in. Files can be exported and downloaded in CSV or Excel format.',
    TOTAL_SKU_SIZE: 'Total SKU Size refers to the total number of pieces, volume or weight of a SKU. The unit of measurement (count, volume in milliliters (ml) and weight in grams (g.)) will vary and is dependent on characteristics of each SKU.',
    SORTBY: 'Default ordering is for SKU details, and using best match for your initial search criteria even when filters are applied. Select from SKU Size and Last Seen Price options for alternative ordering.',
    FIRST_SEEN_PRICE: 'First seen price is the price of a SKU on the first day that SKU was extracted from the retailer website.',
    LAST_SEEN_PRICE: 'Last seen price is the price of a SKU on the most recent day that SKU was extracted from the retailer website.'
};

function getDailyFrequencyTooltipText(): string {
    let tooltipText = 'Your Frequency options depend on the number of SKUs you have selected. If you select Daily (only), you will be limited to the number of days you can extract.\n';

    const limitsDescriptionText = [
        'Full SKU history',
        '2 years of data',
        '1 year of data',
        '4 months of data',
        '2 months of data',
        '1 month of data'
    ];

    limitsDescriptionText.forEach((value, i) => {
        // Single line in code must be preserved here as it will affect the format in the UI.
        // tslint:disable-next-line: max-line-length
        tooltipText = `${tooltipText}\n${DatePicker.DATE_RANGE_LIMITS[i].skuCountLower.toLocaleString('en')}-${DatePicker.DATE_RANGE_LIMITS[i].skuCountUpper.toLocaleString('en')} SKUs: ${limitsDescriptionText[i]}`;
    });

    return tooltipText;
}
